import { requestStarted, requestSucceeded, requestFailed } from './feedbackActionCreators';
import { SET_BANNERS, ADD_BANNER, REMOVE_BANNER } from '../types/bannersTypes';
import Axios from '../../axios/authAxios';

export const setBanners = (banners) => ({ type: SET_BANNERS, payload: banners });
export const addBanner = (banner) => ({ type: ADD_BANNER, payload: banner });
export const removeBanner = (id) => ({ type: REMOVE_BANNER, payload: id });

export const fetchBanners = () => (dispatch) => {
  dispatch(requestStarted());
  Axios.get('/api/banners?populate=image&sort=order:asc')
    .then((res) => {
      dispatch(requestSucceeded());
      dispatch(setBanners(res.data));
    })
    .catch((error) => {
      console.log(error);
      dispatch(requestFailed(error.response.data.message));
    });
};

const uploadBannerImage = (file) => {
  const formData = new FormData();
  formData.append('files', file);
  return Axios({ method: 'post', url: '/api/upload', data: formData }).then(
    (response) => response.data[0].id
  );
};

export const requestAddingBanner = ({ imageFile, productLink, order, isActive }) => async (
  dispatch
) => {
  dispatch(requestStarted());
  try {
    const imageId = await uploadBannerImage(imageFile);
    const res = await Axios.post('/api/banners', {
      data: { image: imageId, productLink, order, isActive },
    });
    dispatch(requestSucceeded('Bannière ajoutée avec succès!'));
    dispatch(addBanner(res.data.data));
    dispatch(fetchBanners());
  } catch (error) {
    console.log(error);
    dispatch(requestFailed((error.response && error.response.data && error.response.data.message) || error.message));
  }
};

export const requestUpdatingBanner = (id, { imageFile, productLink, order, isActive }) => async (
  dispatch
) => {
  dispatch(requestStarted());
  try {
    const data = { productLink, order, isActive };
    if (imageFile) {
      data.image = await uploadBannerImage(imageFile);
    }
    await Axios.put(`/api/banners/${id}`, { data });
    dispatch(requestSucceeded('Bannière mise à jour avec succès!'));
    dispatch(fetchBanners());
  } catch (error) {
    console.log(error);
    dispatch(requestFailed((error.response && error.response.data && error.response.data.message) || error.message));
  }
};

export const requestRemovingBanner = (id) => (dispatch) => {
  dispatch(requestStarted());
  Axios.delete(`/api/banners/${id}`)
    .then(() => {
      dispatch(requestSucceeded('Bannière supprimée avec succès!'));
      dispatch(removeBanner(id));
      dispatch(fetchBanners());
    })
    .catch((error) => {
      console.log(error);
      dispatch(requestFailed((error.response && error.response.data && error.response.data.message) || error.message));
    });
};
